import { FC, PropsWithChildren } from 'react';
import { FixedSurfaceContext } from './FixedSurfaceContext';
import { useStatusBarOverride } from './useStatusBarOverride';

interface IFixedSurfaceProviderProps {
  active?: boolean;
}

// Marks a subtree painted on a background that ignores the colour theme; the nearest provider wins.
export const FixedSurfaceProvider: FC<PropsWithChildren<IFixedSurfaceProviderProps>> = ({
  active = true,
  children
}) => {
  // An inactive provider only resets ink; an outer provider's status-bar override stays,
  // since the bar still sits over the outer surface.
  useStatusBarOverride(active ? 'dark' : null);

  return (
    <FixedSurfaceContext.Provider value={active}>{children}</FixedSurfaceContext.Provider>
  );
};
